import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from "react-router-dom";
import Label from "./label";
import PlayOverlay from './play-overlay';
import createMarkUp from '@medscape-promo/medscapetv/utils/create-markup';

class EpisodeItem extends Component {
    constructor(props) {
        super(props);
        //console.log("[EpisodeItem] props:", props);
        this.linkRef = React.createRef();
    }

    get content() {
        let { title, thumbnail, playing, watched,  episode: episodeNumber, episodeTag, duration } = this.props;
        const posterStyle = {
            backgroundImage: `url(${thumbnail})`
        }

        let episode = episodeTag.length > 0 ? episodeTag : `Episode ${episodeNumber}`;
        return (
            <div className="content-container">
                <div className="flex-content">
                    <div className="image-container" style={ posterStyle }>
                        <Label watched={watched} playing={playing} />
                        <PlayOverlay />
                    </div>
                </div>
                <div className="meta-data">
                    <div className="episode">
                        <span className="episode-tag" dangerouslySetInnerHTML={ { __html: episode} }></span> 
                        &nbsp;|&nbsp; 
                        <span className="episode-duration">{duration}</span>
                    </div>
                    <div className="title">
                        <span dangerouslySetInnerHTML={ createMarkUp(title) } ></span>
                    </div>
                </div>
            </div>
        )
    }
    handleClick(e) {
        this.props.onClick(this.linkRef.current)
        //window.wmdPageLink('mtv-intlink',e.currentTarget);
    }
    componentDidUpdate(prevProps) {
        //console.log("[EpisodeItem] Update:",this.props);
    }
    render() {
        let { href, playing, watched, disableRouting } = this.props;
        const { content } = this;

        const className = cx({
            "watched": watched,
            "playing": playing,
            "video-item": true

        })

        if (disableRouting === true) {
            // Disable Routing if program is loaded in an iframe
            return (
                <a ref={this.linkRef} href={href} onClick={this.handleClick.bind(this)} className={className} target="_blank" rel="noreferrer">{content}</a>
            )
        } else if (playing === true) {
            return (
                <div className={className}>
                    { content }
                </div>
            )
        } else {
            let linkProps = {
                ref: this.linkRef,
                className,
                to: href,
                onClick: this.handleClick.bind(this)

            }
            return (
                <Link {...linkProps} >
                    { content }
                </Link>
            );
        }
    }
    static get propTypes() {
        return {
            episodeTag: PropTypes.string,
            watched: PropTypes.bool,
            disableRouting: PropTypes.bool,
            onClick: PropTypes.func,
            href: PropTypes.string,
            title: PropTypes.string,
            thumbnail: PropTypes.string,
            episode: PropTypes.string,
            duration: PropTypes.string,
            watched: PropTypes.bool,
            playing: PropTypes.bool
        }
    }

    static get defaultProps() {
        return {
            episodeTag: "",
            watched: false,
            disableRouting: false,
            onClick: () => {},
            title: "",
            thumbnail: "",
            episode: "",
            duration: "",
            watched: false,
            playing: false
        }
    }
}





export default EpisodeItem